const echarts = require("echarts");

export const charttwo = (arr1, arr2) => {
  return {
    grid: {
      top: "50",
      left: "10",
      right: "10",
      bottom: "10",
      containLabel: true,
    },
    tooltip: {
      trigger: "axis",
      // axisPointer: {
      //   type: "shadow",
      // },
    },
    legend: {
      show: true,
      // x: "center",
      top: "20",
      icon: "rect",
      textStyle: {
        color: "#fff",
        fontSize: "8",
      },
      data: ["上行", "下行"],
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      axisTick: {
        alignWithLabel: true,
      },
      splitLine: {
        show: false,
      },
      nameTextStyle: {
        color: "#fff",
      },
      axisLabel: {
        color: "#fff",
      },
      axisTick: {
        show: false, //隐藏x轴刻度
      },
      data: ["4.1", "4.3", "4.4", "4.5", "4.6"],
    },
    yAxis: {
      type: "value",
      axisTick: {
        alignWithLabel: true,
      },
      splitLine: {
        show: false,
      },
      nameTextStyle: {
        color: "#fff",
      },
      axisLabel: {
        color: "#fff",
      },
      axisTick: {
        show: false, //隐藏x轴刻度
      },
    },
    series: [
      {
        name: "上行",
        data: arr1,
        type: "line",
        smooth: false,
        itemStyle: {
          normal: {
            color: "#A2FFFF",
            borderColor: "#A2FFFF",
          },
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(101, 251, 248)",
            },
            {
              offset: 1,
              color: "rgb(19, 33, 52)",
            },
          ]),
        },
      },
      {
        name: "下行",
        data: arr2,
        type: "line",
        smooth: false,
        itemStyle: {
          normal: {
            lineStyle: {
              type: "dotted",
            },
            color: "#F9F262",
            borderColor: "#F9F262",
          },
        },
        areaStyle: {
          opacity: 0.8,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: "rgb(249, 242, 98)",
            },
            {
              offset: 1,
              color: "rgb(19, 33, 52)",
            },
          ]),
        },
      },
    ],
  };
};
export const chartone = (data) => {
  return {
    color: "#277ede",
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    grid: {
      left: "10%",
      right: "5%",
      bottom: "3%",
      top: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      boundaryGap: [0, 0.01],
      axisLabel: {
        color: "#bfc9d3",
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      data: [
        "长者码组件",
        "老人能力评估组件",
        "疫情防控组件",
        "护理员培育组件",
        "一床一码组件",
      ],
      axisTick: {
        show: false,
      },
      splitLine: {
        show: false,
      },
      axisLabel: {
        color: "#bfc9d3",
      },
    },
    series: [
      {
        name: "",
        type: "bar",
        data,
      },
    ],
  };
};
